module.exports = __webpack_public_path__ + "assets/fd870b2b6737ab24f0fe5cc78d661667.png";